import { UserApi } from "certiblok-api-manager";
import { useSetAtom } from "jotai";
import Cookies from "js-cookie";
import { useCallback } from "react";
import { useApi } from "./api";
import { AbilityAtomStorage, useResetAbilities } from "./useAbilityRules";

export function useGenerateNewAbilities() {
	const userApi = useApi(UserApi);
	const setAbility = useSetAtom(AbilityAtomStorage);

	const resetAbilities = useResetAbilities();

	return useCallback(() => {
		userApi
			.invalidCurrentAbilities()
			.then((resp) => {
				resetAbilities();
				setAbility(resp.data?.abilityRules || []);
				//After we invalidate the current abilities the auth override token gets invalidated and we need to remove it in order to use the usual cookie based auth
				//After invalidating abilities a new CertiblokAccessToken cookie gets set so we are good to go
				Cookies.remove("CertiblokAuthOverride", { domain: "mabiloft.com" });
			})
			.catch((err) => console.log("NEW ABILITIES", err));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [setAbility, userApi]);
}
